import { MedicalDataTypes } from '../../primary-record-types';

export const relatedResourcesMap: Record<
    MedicalDataTypes.PrimaryRecordResourceCategory,
    MedicalDataTypes.PrimaryRecordResourceCategory[]
> = {
    condition: ['medication', 'visit'],
    allergy: [],
    medication: ['condition', 'visit'],
    visit: ['medication', 'condition'],
    vaccination: [],
    procedure: [],
    imaging: [],
    lab: [],
};
